import React, { useEffect, useRef, useState } from "react";
import { useAuth } from "../auth/FirebaseAuth.js";

import {
  adjustColorOpacity,
  darkenColor,
  getEventsByOrgRef,
  getOrgById,
  getOrgByRef,
  isColorTooDark,
  lightenColorToLuminanceAbove200,
} from "../models/OrgFunctions.js"; // Functions to fetch org and client data

import Space from "../layout/Space.js";
import { useTheme } from "@mui/material";
import { fr, is } from "date-fns/locale"; // Importing the French locale

import {
  getArrayDocDataByID,
  getArrayDocDataByRef,
  getDateFromFlutter,
  getDateFromSeconds,
  getDocDataById,
  getDocDataByRef,
  getFlutterTimeFromSeconds,
  getOrgDataById,
  getRefFromId,
  getUserDataById,
  getWorkspaceDataById,
  queryCollection,
} from "../models/DataFunctions.js";
import { flutterColorToHex, HexColorToFlutter } from "../config/theme.js";
import { useAppContext } from "../config/AppContext.js";
import moment, { duration } from "moment";

import {
  format,
  addWeeks,
  subWeeks,
  startOfWeek,
  endOfWeek,
  isWithinInterval,
  set,
  lightFormat,
} from "date-fns";
import EventModal from "./EventModal.js";
import createNewEvent from "../api/create/createNewEvent.js";
import { getOrRefreshFirebaseToken } from "../config/getFirebaseToken.js";

import { useSnackbar } from "notistack";
import updateDocDataFieldApi from "../api/database/updateDocDataFieldApi.js";
import modifyEvent from "../api/modify/modifyEvent.js";
import SearchBarEvents from "../textfields/SearchBarEvents.js";
import dayjs from "dayjs";
import { name } from "dayjs/locale/fr.js";
import createDocApi from "../api/database/createDocApi.js";
import SmallSpinner from "../loading/SmallSpinner.js";
import DropDownGPT03 from "../dropdowns/DropDownGTP03.js";
import { PlanningEvent } from "./PlanningEvent.js";
import { PlanningHeader } from "./PlanningHeader.js";
import { isFolderClient } from "../hexagone/VisibilityHelpers.js";
import { Spin } from "antd";
import { PlanningWeekView } from "./PlanningWeekView.js";
import { PlanningDayView } from "./PlanningDayView.js";
import SearchAlgolia from "../textfields/SearchAlgolia.js";
import {
  queryCollectionAlgolia,
  queryEvents,
} from "../models/AlgoliaFunctions.js";
import Icon1 from "../icons/Icon.js";

function Planning3({
  userData,
  orgData,
  navigateWorkspace,
  overrideId,
  workspaceData,
  masterData,
}) {
  const theme = useTheme();
  const { currentUser, loading } = useAuth();

  const { appState, setAppState, setEventFilter } = useAppContext();
  const saved_data = appState.saved_data;
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;

  const searchParams = new URLSearchParams(window.location.search);
  const navigation_date = searchParams.get("date") || "";
  const navigation_event_id = searchParams.get("event_id") || "";
  const [loadingFetchEvents, setLoadingFetchEvents] = useState(true);

  const [searchValue, setSearchValue] = useState("");
  const [rows, setRows] = useState([]);
  const [operators, setOperators] = useState([]);

  const planning_config = appState.planning_config;
  const [selected_operators, setSelectedOperators] = useState(
    planning_config?.selected_operators &&
      planning_config.selected_operators.length > 0
      ? planning_config.selected_operators
      : ["all"]
  );
  const [clients, setClients] = useState([]);
  const [users, setUsers] = useState([]);
  const [options, setOptions] = useState([]);
  const [open, setOpen] = useState({});
  const [modal_open, setModalOpen] = useState(false);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [events_colors, setEventsColors] = useState(null); // State to store event colors
  const [searchEvents, setSearchEvents] = useState(true);
  const [day_view, setDayView] = useState(planning_config?.day_view || null);
  const [show_weekend, setShowWeekend] = useState(
    planning_config?.show_weekend === null
      ? true
      : planning_config?.show_weekend
  );
  const [simplified_view, setSimplifiedView] = useState(
    planning_config?.simplified_view === null
      ? false
      : planning_config?.simplified_view
  );

  const [pack_short_dict, setPackShortDict] = useState({});

  const [currentWeekStart, setCurrentWeekStart] = useState(
    startOfWeek(
      navigation_date
        ? set(new Date(), {
            year: parseInt(navigation_date.split("/")[2]),
            month: parseInt(navigation_date.split("/")[1]) - 1,
            date: parseInt(navigation_date.split("/")[0]),
          })
        : planning_config
          ? planning_config.date
          : new Date(),
      {
        weekStartsOn: 1,
      }
    )
  );
  const [highligtedEvent, setHighligtedEvent] = useState(null);
  const gotoEventName = async (name) => {
    if (!name.value) return;
    // Find the client with the matching name
    let event = await getDocDataById("event", name.value);
    if (!event) {
      console.error("Event not found:", name.value);
      handleClickVariant("Événement non trouvé", "error");
      return;
    }
    const startDate2 = new Date(event.start.seconds * 1000);
    const startDate = getDateFromFlutter(event.start);
    console.log(startDate2, startDate);
    const endDate = getDateFromFlutter(event.end);
    event.startDate = startDate; // Store the full date object to filter later
    event.endDate = endDate;

    event.weekdate = capitalizeFirstLetter(
      format(startDate, "EEEE", { locale: fr })
    );
    event.startTime = format(startDate, "HH:mm");
    event.endTime = format(endDate, "HH:mm");

    // open the modal of the event
    let members_id = event.members_id;
    // if the event members are not in the selected operators add them
    if (members_id && members_id.length > 0) {
      for (let i = 0; i < members_id.length; i++) {
        if (!selected_operators.includes(members_id[i])) {
          handleSelectedOperators(members_id[i]);
        }
      }
    } else {
      setSelectedOperators(["all"]);
    }
    // change week to the week of the event
    const newWeekStart = startOfWeek(event.startDate, { weekStartsOn: 1 });
    console.log("newWeekStart", newWeekStart);
    setCurrentWeekStart(newWeekStart); // Update the state
    let new_planning_config = { ...planning_config };
    new_planning_config.date = newWeekStart;
    setAppState({
      ...appState,
      planning_config: new_planning_config,
    });

    let all_events = await fetchMonthEvents(newWeekStart);
    console.log("all_events", all_events);

    let weekEvents = await getEventsForWeek(
      all_events,
      newWeekStart,
      endOfWeek(newWeekStart, { weekStartsOn: 1 })
    );

    setTimeout(async () => {
      setEvents(weekEvents); // Filter events for the new week
      await fetchEventColors(weekEvents);
      await getEventShort(weekEvents);
      setHighligtedEvent(event.id);
      handleOpenModal(event.id);
    }, 500);
  };

  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };

  // Helper function to get dates of the current week (Monday to Friday)
  const getCurrentWeekDates = (weekStartDate) => {
    return Array.from({ length: 7 }, (_, i) => {
      const date = new Date(weekStartDate);
      date.setDate(weekStartDate.getDate() + i);
      return date; // Return the full Date object for each day
    });
  };

  const weekDates = getCurrentWeekDates(currentWeekStart); // Get the current week's dates
  const daysOfWeek = show_weekend
    ? ["Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi", "Dimanche"]
    : ["Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi"];

  const handleSelectedOperators = (selected) => {
    let new_planning_config = { ...planning_config };
    let new_selected_operators;

    if (selected === "all") {
      if (selected_operators.includes("all")) {
        new_selected_operators = selected_operators.filter(
          (item) => item !== "all"
        );
        setSelectedOperators(new_selected_operators);
      } else {
        new_selected_operators = ["all"];
        setSelectedOperators(new_selected_operators);
      }
    } else if (selected === "no_operator") {
      if (selected_operators.includes("no_operator")) {
        new_selected_operators = selected_operators.filter(
          (item) => item !== "no_operator"
        );
        setSelectedOperators(new_selected_operators);
      } else {
        new_selected_operators = ["no_operator"];
        setSelectedOperators(new_selected_operators);
      }
    } else {
      if (selected_operators.includes(selected)) {
        new_selected_operators = selected_operators.filter(
          (item) => item !== selected
        );
        setSelectedOperators(new_selected_operators);
      } else {
        new_selected_operators = [
          ...selected_operators.filter(
            (item) => item !== "all" && item !== "no_operator"
          ),
          selected,
        ];
        setSelectedOperators(new_selected_operators);
      }

      if (new_selected_operators.length === 0) {
        new_selected_operators = ["all"];
        setSelectedOperators(new_selected_operators);
      }
    }
    new_planning_config.selected_operators = new_selected_operators;
    setAppState({
      ...appState,
      planning_config: new_planning_config,
    });
  };
  // Function to go to the previous week
  const previousWeek = async (e) => {
    e.preventDefault();
    const newWeekStart = subWeeks(currentWeekStart, 1); // Calculate the previous week
    setCurrentWeekStart(newWeekStart); // Update the state

    let new_planning_config = { ...planning_config };
    new_planning_config.date = newWeekStart;
    setAppState({
      ...appState,
      planning_config: new_planning_config,
    });

    let weekEvents = await getEventsForWeek(
      all_events,
      newWeekStart,
      endOfWeek(newWeekStart, { weekStartsOn: 1 })
    );
    setEvents(weekEvents); // Filter events for the new week
    await fetchEventColors(weekEvents);
    await getEventShort(weekEvents);
    await fetchMonthEvents(newWeekStart);
  };

  // Function to go to the previous week
  const currentWeek = async (e) => {
    e.preventDefault();

    // get the week of today
    const today = new Date();
    const newWeekStart = startOfWeek(today, { weekStartsOn: 1 }); // Calculate the previous week
    setCurrentWeekStart(newWeekStart); // Update the state
    let all_events = await fetchMonthEvents(newWeekStart);

    let new_planning_config = { ...planning_config };
    new_planning_config.date = newWeekStart;
    setAppState({
      ...appState,
      planning_config: new_planning_config,
    });

    let weekEvents = await getEventsForWeek(
      all_events,
      newWeekStart,
      endOfWeek(newWeekStart, { weekStartsOn: 1 })
    );
    setEvents(weekEvents); // Filter events for the new week
    await fetchEventColors(weekEvents);
    await getEventShort(weekEvents);
  };

  const [temporary, setTemporary] = useState(false);
  // Initialize state to the start of the current week (Monday)
  const [events, setEvents] = useState([]); // State to store events
  const [all_events, setAllEvents] = useState([]); // State to store all events
  const [loadingWeek, setLoadingWeek] = useState(false);
  const clicked_again = useRef(false);
  // Function to go to the next week
  const debounceTimerRef = useRef(null);
  const pendingWeekChangeRef = useRef(0);
  const originalWeekRef = useRef(new Date()); // Track the week before any pending changes

  // Function to go to the next week with debounce
  const nextWeek = (e, previous = false) => {
    e.preventDefault();
    let increment = previous ? -1 : 1;

    // If already loading, just increment the pending changes and return

    // Clear any existing timer
    if (debounceTimerRef.current) {
      clearTimeout(debounceTimerRef.current);
    }
    if (pendingWeekChangeRef.current === 0) {
      originalWeekRef.current = currentWeekStart;
    }

    // Increment pending changes
    pendingWeekChangeRef.current += increment;
    console.log("pendingWeekChangeRef", pendingWeekChangeRef.current);
    console.log("originalWeekRef.current", originalWeekRef.current);

    const newWeekStart = addWeeks(
      originalWeekRef.current,
      pendingWeekChangeRef.current
    );
    setCurrentWeekStart(newWeekStart);

    // Set loading state immediately for UI feedback
    setLoadingWeek(true);

    // Set debounce timer
    debounceTimerRef.current = setTimeout(async () => {
      try {
        // Get the total number of weeks to advance
        const totalWeeksToAdvance = pendingWeekChangeRef.current;
        const finalWeekStart = addWeeks(
          originalWeekRef.current,
          totalWeeksToAdvance
        );
        console.log("finalWeekStart", finalWeekStart);

        // Reset pending counter
        pendingWeekChangeRef.current = 0;
        let all_events = await fetchMonthEvents(finalWeekStart);

        let weekEvents = await getEventsForWeek(
          all_events,
          finalWeekStart,
          endOfWeek(finalWeekStart, { weekStartsOn: 1 })
        );
        const we = weekEvents;
        setEvents(we);

        let new_planning_config = { ...planning_config };
        new_planning_config.date = finalWeekStart;
        setAppState({
          ...appState,
          planning_config: new_planning_config,
        });

        await fetchEventColors(we);
        await getEventShort(we);
      } catch (error) {
        console.error("Error in nextWeek:", error);
      } finally {
        setLoadingWeek(false);
      }
    }, 400); // 2 second delay
  };

  // Clean up timer on component unmount
  useEffect(() => {
    return () => {
      if (debounceTimerRef.current) {
        clearTimeout(debounceTimerRef.current);
      }
    };
  }, []);

  const getEventsForWeek = async (all_events = [], weekStart, weekEnd) => {
    try {
      console.log("Getting events for week:", weekStart, weekEnd);
      // Helper function to calculate the week number for a given date

      const currentWeekNumber = getWeekNumber(weekStart);
      console.log(
        "currentWeekNumber",
        currentWeekNumber,
        workspaceData,
        orgData
      );
      let all_frequency_events =
        (await queryEvents(workspaceData, orgData, [
          {
            field: "frequency",
            operator: "in",
            value: [
              "daily",
              "weekly",
              "weekly2",
              "weekly3",
              "monthly",
              "weekly5",
              "weekly6",
            ],
          },
        ])) || [];
      console.log("all_frequency_events", all_frequency_events);

      all_frequency_events = transformEventDB(all_frequency_events);
      console.log("all_frequency_events", all_frequency_events);
      // Weekly events occur every week

      let visible_frequency_events = all_frequency_events.filter(
        (event) =>
          event.frequency === "daily" ||
          event.frequency === "weekly" ||
          (event.frequency === "weekly2" &&
            getWeekNumber(new Date(event.start.seconds * 1000)) % 2 ===
              currentWeekNumber % 2) ||
          (event.frequency === "weekly3" &&
            getWeekNumber(new Date(event.start.seconds * 1000)) % 3 ===
              currentWeekNumber % 3) ||
          (event.frequency === "monthly" &&
            getWeekNumber(new Date(event.start.seconds * 1000)) % 4 ===
              currentWeekNumber % 4) ||
          (event.frequency === "weekly5" &&
            getWeekNumber(new Date(event.start.seconds * 1000)) % 5 ===
              currentWeekNumber % 5) ||
          (event.frequency === "weekly6" &&
            getWeekNumber(new Date(event.start.seconds * 1000)) % 6 ===
              currentWeekNumber % 6)
      );

      let visible_events = [...all_events, ...visible_frequency_events];

      let all = visible_events.filter(
        (event) =>
          isWithinInterval(event.startDate, {
            start: weekStart,
            end: weekEnd,
          }) ||
          (isWithinInterval(event.startDate, {
            start: new Date(0),
            end: weekEnd,
          }) &&
            (event.frequency === "daily" ||
              event.frequency === "weekly" ||
              (event.frequency === "weekly2" &&
                getWeekNumber(new Date(event.start.seconds * 1000)) % 2 ===
                  currentWeekNumber % 2) ||
              (event.frequency === "weekly3" &&
                getWeekNumber(new Date(event.start.seconds * 1000)) % 3 ===
                  currentWeekNumber % 3) ||
              (event.frequency === "monthly" &&
                getWeekNumber(new Date(event.start.seconds * 1000)) % 4 ===
                  currentWeekNumber % 4) ||
              (event.frequency === "weekly5" &&
                getWeekNumber(new Date(event.start.seconds * 1000)) % 5 ===
                  currentWeekNumber % 5) ||
              (event.frequency === "weekly6" &&
                getWeekNumber(new Date(event.start.seconds * 1000)) % 6 ===
                  currentWeekNumber % 6)))
      );
      // remove duplicates
      all = all.filter(
        (event, index, self) =>
          index === self.findIndex((e) => e.id === event.id)
      );
      console.log("all events for the week", all);
      return all;
    } catch (error) {
      console.error("Error in getEventsForWeek:", error);
      return [];
    }
  };

  const handleGoToToday = async () => {
    const today = new Date();
    const newWeekStart = startOfWeek(today, { weekStartsOn: 1 }); // Calculate the previous week
    setCurrentWeekStart(newWeekStart); // Update the state

    let new_planning_config = { ...planning_config };
    new_planning_config.date = newWeekStart;
    setAppState({
      ...appState,
      planning_config: new_planning_config,
    });

    let weekEvents = await getEventsForWeek(
      all_events,
      newWeekStart,
      endOfWeek(newWeekStart, { weekStartsOn: 1 })
    );
    setEvents(weekEvents); // Filter events for the new week
    await fetchEventColors(weekEvents);
    await getEventShort(weekEvents);
    setDayView(new Date().getDay() - 1);
  };

  const [algoliaResults, setAlgoliaResults] = useState([]);

  const handleQuerySearch = async (searchTerm) => {
    console.log("Searching Algolia with term:", searchTerm);
    let folders_filters = [
      {
        field: "master_id",
        operator: "==",
        value: orgData.id,
      },
    ];

    let results = await queryCollectionAlgolia(
      "event",
      folders_filters,
      searchTerm,
      50
    );
    console.log("Results from Algolia:", results);
    setAlgoliaResults(results);
    setSearchValue(searchTerm);
  };

  const [loadingAddingLunchBreak, setLoadingAddingLunchBreak] = useState(false);
  const handleAddLunchBreak = async () => {
    setLoadingAddingLunchBreak(true);
    setCanFetch(false);
    if (workspaceData) {
      return;
    }

    // adding a event of type "Pause déjeuner" from 12:30 to 13:30 for all days of the week
    // get the first day of the week
    for (let i = 0; i < operators.length; i++) {
      // i need the sseconds
      // set the day of the week
      let current_day = weekDates[day_view];

      const current_daySeconds = current_day.getTime() / 1000;
      let start = new Date(current_daySeconds * 1000); // Convert back to milliseconds
      start.setHours(12);
      start.setMinutes(30);

      let end = new Date(current_daySeconds * 1000); // Convert back to milliseconds
      end.setHours(13);
      end.setMinutes(30);
      const body = {
        title: "Pause déjeuner",
        start: getFlutterTimeFromSeconds(start.getTime() / 1000),
        end: getFlutterTimeFromSeconds(end.getTime() / 1000),
        name: "Pause déjeuner",
        type: "Pause déjeuner",
        master_id: orgData.id,
        members: [operators[i].id],
      };
      await createDocApi("event", body, prefix);
    }
    handleClickVariant("Pauses déjeuner ajoutées", "success");
    setCanFetch(true);
    setLoadingAddingLunchBreak(false);
  };

  const [last_can_fetch, setLastCanFetch] = useState(true);
  const [last_saved_data, setLastSavedData] = useState(null);
  const [last_org_data, setLastOrgData] = useState(null);

  const [isFetching, setIsFetching] = useState(false);
  const [can_fetch, setCanFetch] = useState(true);
  useEffect(() => {
    if (currentUser) {
      handleFetchData();
    }
  }, [currentUser]);

  const handleExtraFetch = async (saved_data, orgData) => {
    if (!isFetching) {
      if (saved_data && saved_data.events) {
        if (orgData) {
          setIsFetching(true);
          await fetchAllEvents();
          setIsFetching(false);
        } else {
          setCanFetch(true);
        }
      } else {
        if (orgData) {
          setIsFetching(true);
          await fetchAllEvents();
          setIsFetching(false);
        } else {
          setCanFetch(true);
        }
      }
    }
  };

  function checkExceptionDates(eventA, eventB) {
    const dateString = new Date(
      eventA.start.seconds * 1000
    ).toLocaleDateString(); // dd/MM/yyyy
    if (
      eventA.exception_dates?.includes(dateString) ||
      eventB.exception_dates?.includes(dateString)
    ) {
      return false; // If either event has an exception date, they are not the same
    }

    return true; // No exception dates found, consider them the same
  }

  function sameMembers(event1, event2) {
    const members1 = event1?.members_id || [];
    const members2 = event2?.members_id || [];

    if (members1.length === 0 || members2.length === 0) {
      return false; // Both events have no members, consider them the same
    }

    members1.sort();
    members2.sort();

    const sameMembers =
      members1.length === members2.length &&
      members1.every((id, i) => id === members2[i]);
    return sameMembers;
  }

  useEffect(() => {
    setLastCanFetch(can_fetch);
    setLastSavedData(saved_data);
    setLastOrgData(orgData);
    // I want to know what caused the useEffect to run
    if (can_fetch) {
      setCanFetch(false);
      handleExtraFetch(saved_data, orgData);
    }
  }, [saved_data, orgData, can_fetch]);
  const [hidden_index, setHiddenIndex] = useState(0);
  const [hidden_events, setHiddenEvents] = useState([]);
  const findSuperposedEvents = (events) => {
    // First, ensure all events have valid start and end seconds
    const validEvents = events.filter(
      (event) => event.start?.seconds && event.end?.seconds
    );

    const superposedEvents = [];

    // Compare each event with all other events to find overlaps
    for (let i = 0; i < validEvents.length; i++) {
      const eventA = validEvents[i];

      for (let j = i + 1; j < validEvents.length; j++) {
        const eventB = validEvents[j];

        // Check if events overlap
        const overlap =
          ((eventA.end.seconds >= eventB.end.seconds &&
            eventA.start.seconds <= eventB.start.seconds) ||
            (eventB.end.seconds >= eventA.end.seconds &&
              eventB.start.seconds <= eventA.start.seconds)) &&
          sameMembers(eventA, eventB) &&
          checkExceptionDates(eventA, eventB);

        if (overlap) {
          // If we haven't added this event to the superposed list yet, add it
          if (!superposedEvents.includes(eventA)) {
            superposedEvents.push(eventA);
          }

          // Add the other event to the superposed list
          if (!superposedEvents.includes(eventB)) {
            superposedEvents.push(eventB);
          }
        }
      }
    }

    return superposedEvents;
  };

  const fetchMonthEvents = async (newWeekStarto) => {
    if (planning_config?.date && typeof planning_config?.date === "string") {
      planning_config.date = new Date(planning_config.date);
    }

    let one_month_ago = getDateFromSeconds(
      newWeekStarto?.getTime() / 1000 ||
        planning_config?.date?.getTime() / 1000 ||
        new Date().getTime() / 1000
    );
    one_month_ago.setMonth(one_month_ago.getMonth() - 1);
    let next_month = getDateFromSeconds(
      newWeekStarto?.getTime() / 1000 ||
        planning_config?.date?.getTime() / 1000 ||
        new Date().getTime() / 1000
    );
    next_month.setMonth(next_month.getMonth() + 1);

    let query_events = await queryEvents(workspaceData, orgData, [
      {
        field: "start",
        operator: ">=",
        value: getFlutterTimeFromSeconds(one_month_ago.getTime() / 1000),
      },
      {
        field: "start",
        operator: "<=",
        value: getFlutterTimeFromSeconds(next_month.getTime() / 1000),
      },
    ]);
    const allEvents = [];

    for (const event of query_events) {
      if (event.start.seconds && event.end.seconds) {
        // Convert Firestore Timestamps to Date
        const startDate = new Date(event.start.seconds * 1000);
        const endDate = new Date(event.end.seconds * 1000);

        let dict_event = event;

        dict_event.startDate = startDate; // Store the full date object to filter later
        dict_event.endDate = endDate;

        dict_event.weekdate = capitalizeFirstLetter(
          format(startDate, "EEEE", { locale: fr })
        );
        dict_event.startTime = format(startDate, "HH:mm");
        dict_event.endTime = format(endDate, "HH:mm");
        dict_event.title = event.title || "Titre";
        dict_event.name = event.name || "Titre";

        dict_event.client_name = event.client_name || "";
        dict_event.pack_name = event.pack_name || "";
        dict_event.pack_ref = event.pack_ref;
        dict_event.ville = event.ville || "";

        allEvents.push(dict_event);
      }
    }
    let superposed = findSuperposedEvents(query_events);
    setHiddenEvents(superposed);
    setAllEvents(allEvents); // Store all events in state

    return allEvents;
  };

  const fetchAllEvents = async (newWeekStarto) => {
    try {
      const allEvents = await fetchMonthEvents(newWeekStarto);
      // I want to find all events that superposed meaning event a and b have the same start.seconds and end.seconds

      // Fetch all events once from the database

      if (!workspaceData) {
        const filters = [
          {
            field: "masters_id",
            operator: "array-contains",
            value: orgData.id,
          },
        ];
        const clients = await queryCollection("org", filters);
        setClients(clients);
      }

      let users = await getArrayDocDataByID("user", orgData.users_id);
      let users_operator = users.filter((user) => user.role === "operator");
      setUsers(users_operator);
      let selectedUsers = users;
      selectedUsers = ["Sans opérateur", ...users];
      setSelectedUsers(["all"]);

      const the_events = allEvents;

      const open_events_dict = the_events.reduce((acc, event) => {
        acc[event.id] = open[event.id] || false;
        return acc;
      }, {});
      setOpen(open_events_dict);

      const newWeekStart = subWeeks(currentWeekStart, 0); // Calculate the previous week

      let new_planning_config = { ...planning_config };
      new_planning_config.date = newWeekStart;
      setAppState({
        ...appState,
        planning_config: new_planning_config,
      });

      setCurrentWeekStart(newWeekStart); // Update the state
      const weekevents = await getEventsForWeek(
        allEvents,
        newWeekStart,
        endOfWeek(newWeekStart, { weekStartsOn: 1 })
      );
      const weekagendaevents = weekevents;
      setEvents(weekagendaevents); // Filter events for the current week
      await fetchEventColors(weekevents);
      await getEventShort(weekevents);
      setLoadingFetchEvents(false);

      if (navigation_event_id) {
        console.log("navigation_event_id", navigation_event_id);
        handleOpenModal(navigation_event_id);
        // remove the event_id from the url without refreshing the page
        window.history.replaceState(
          {},
          document.title,
          window.location.pathname
        );
      }
    } catch (error) {
      console.error(error);
    }
  };

  async function getEventShort(events) {
    let dict = pack_short_dict;
    const promises = events.map(
      async (event) => (dict = await getShortPack(event.pack_ref, dict))
    );

    const results = await Promise.all(promises);

    // Merge all results into a single dictionary
    const new_pack_short_dict = results.reduce(
      (acc, dict) => ({ ...acc, ...dict }),
      {}
    );

    // Update state once
    setPackShortDict(new_pack_short_dict);
  }

  const handleSetDayView = (index) => {
    let new_day_view = index;
    setDayView(new_day_view);
    let new_planning_config = { ...planning_config };
    new_planning_config.day_view = new_day_view;
    setAppState({
      ...appState,
      planning_config: new_planning_config,
    });
  };

  async function getShortPack(pack_ref, pack_short_dict) {
    let pack_id = pack_ref?.id;
    if (pack_short_dict[pack_id]) {
      return pack_short_dict;
    } else {
      if (!pack_id) {
        return pack_short_dict;
      } else {
        let pack = await getDocDataByRef(pack_ref);

        if (!pack) {
          let new_pack_short_dict = { ...pack_short_dict };
          new_pack_short_dict[pack_id] = "";

          return new_pack_short_dict;
        } else {
          let short = pack.short || "";
          let new_pack_short_dict = { ...pack_short_dict };
          new_pack_short_dict[pack_id] = short;

          return new_pack_short_dict;
        }
      }
    }
  }

  // Fun
  // Generate time intervals dynamically from 07:00 to 21:00
  const timeSlots = [8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20]; // Time slots for the scheduler

  // Helper function to convert time (HH:mm) to minutes since the start of the day
  // Helper function to convert time (HH:mm) to minutes since the start of the day
  const timeToMinutes = (time) => {
    if (!time) return 0; // If time is undefined or null, return 0 (or handle as needed)

    const [hours, minutes] = time.split(":").map(Number); // Safely split the time
    return hours * 60 + minutes;
  };
  const [operator_colors, setOperatorColors] = useState({});

  const fetchEventColors = async (no_coordinates_events) => {
    let new_operator_colors = operator_colors;
    let events = no_coordinates_events;
    let event_colors = {};
    setEvents(events);
    if (events_colors) {
      // copy the existing colors
      // loops through the keys
      for (const [key, value] of Object.entries(events_colors)) {
        // check if the key is in the new events
        event_colors[key] = value;
      }
    }

    for (let i = 0; i < events.length; i++) {
      let event = events[i];
      // check if already in the event_colors

      let members_id = event.members_id;
      let memberdata;
      let newcolors = [];
      if (members_id && members_id.length > 0) {
        for (let i = 0; i < members_id.length; i++) {
          let member_id = members_id[i];
          if (new_operator_colors[member_id]) {
            newcolors.push(new_operator_colors[member_id]);
          } else {
            memberdata = await getUserDataById(member_id);
            if (memberdata?.color) {
              newcolors.push(memberdata?.color);
              new_operator_colors[memberdata.id] = memberdata?.color;
            }
          }
        }
      } else {
        newcolors.push(1);
      }
      if (newcolors.length > 0) {
        event_colors[event.id] = newcolors;
      }
    }
    setEventsColors(event_colors);
    setOperatorColors(new_operator_colors);
  };

  // If client exists, navigate to the client page by ID

  // Function to navigate to a client by ID

  const handleOpenModal = (eventId) => {
    if (open[eventId]) {
      setOpen((prev) => ({ ...prev, [eventId]: false })); // Close the modal for the specific event
      setCanFetch(true);
      setModalOpen(false);
    } else {
      setOpen((prev) => ({ ...prev, [eventId]: true })); // Open the modal for the specific event
      setCanFetch(false);
      setModalOpen(true);
    }
  };

  const handleCloseModal = (eventId) => {
    setOpen((prev) => ({ ...prev, [eventId]: false })); // Close the modal for the specific event
    setModalOpen(false);
  };

  const onDelete = (id) => {
    const weekevents = events.filter((event) => event.id !== id);
    const weekevents2 = weekevents;
    const allevents = all_events.filter((event) => event.id !== id);
    setEvents(weekevents2);
    setAllEvents(allevents);
    handleClickVariant("Évènement supprimé", "success");
    setCanFetch(true);
    setOpen((prev) => ({ ...prev, [id]: false })); // Close the modal for the specific event
    setSearchValue("");
    setHighligtedEvent(null);
  };

  function getDateTimeFromClickEvent(e) {
    const schedulerDiv = e.currentTarget;
    const rect = schedulerDiv.getBoundingClientRect();
    const x = e.clientX - rect.left; // X position relative to the div
    const y = e.clientY - rect.top; // Y position relative to the div

    // Calculate slot dimensions
    const slotHeight = schedulerDiv.offsetHeight / (timeSlots.length * 4); // Each hour has 4 slots (15 minutes each)
    const slotWidth = schedulerDiv.offsetWidth / daysOfWeek.length; // Width of each day slot

    // Determine the exact time slot in 15-minute intervals
    const clickedTimeIndex = Math.floor(y / slotHeight);
    const clickedDateIndex = Math.floor(x / slotWidth);

    // Extract the hour and minute from the selected time slot
    const clickedTime = timeSlots[Math.floor(clickedTimeIndex / 4)]; // e.g., "08:00"
    const baseHour = clickedTime; // Convert to integers

    // Calculate the minute within the hour based on the 15-minute interval
    const startmin = (clickedTimeIndex % 4) * 15; // Calculate the exact 15-minute interval within the hour
    const starthour = baseHour; // The hour part remains the same from the time slot

    // Calculate end time as 15 minutes after the start time
    let endhour = starthour;
    let endmin = startmin + 15;

    // Adjust endhour and endmin if endmin exceeds 60
    if (endmin >= 60) {
      endhour += 1;
      endmin -= 60;
    }

    const clickedDay = weekDates[clickedDateIndex]; // Full Date object for the clicked day
    const parsedDate = format(clickedDay, "dd/MM/yyyy", { locale: fr });

    return {
      starthour,
      endhour,
      startmin,
      endmin,
      parsedDate,
    };
  }

  const [newEventPlacement, setNewEventPlacement] = useState(null);
  const handleClick = async (
    e,
    day_index = 0,
    operator_id = null,
    hour = null
  ) => {
    const opened = Object.values(open).some((value) => value === true);
    if (opened) {
      return;
    }
    if (!orgData) {
      return;
    }
    if (workspaceData) {
      return;
    }

    setNewEventPlacement(false);

    let { starthour, endhour, startmin, endmin, parsedDate } =
      getDateTimeFromClickEvent(e);
    if (hour !== null) {
      starthour = hour;
    }

    let actual_day = weekDates[day_index];
    parsedDate = format(actual_day, "dd/MM/yyyy", { locale: fr });
    endmin = 0;
    startmin = 0;

    endhour = starthour + 1;

    const event_id = await createNewEvent(
      starthour,
      endhour,
      startmin,
      endmin,
      parsedDate, // The full date in "dd/MM/yyyy" format
      "", // Placeholder event name (you can change this)
      "", // Placeholder event description (you can change this)
      orgData.id,
      prefix
    );
    if (!event_id) {
      handleClickVariant("Hors des heures de travail", "error");
      return;
    }
    const eventRef = getRefFromId("event", event_id);
    if (
      selected_operators &&
      selected_operators.length > 0 &&
      selected_operators[0] !== "all"
    ) {
      let member = selected_operators[0];
      await updateDocDataFieldApi(eventRef, "members_id", [member], prefix);
    }
    if (day_view !== null && operator_id !== null) {
      await updateDocDataFieldApi(
        eventRef,
        "members_id",
        [operator_id],
        prefix
      );
    }

    const newEvent = await getDocDataByRef(eventRef);
    await onCreate(newEvent);
  };

  function getWeekNumber(d) {
    d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
    d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
    var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
    var weekNo = Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
    return weekNo;
  }

  const onCreate = async (event, folder) => {
    try {
      setTemporary(true);

      const startDate = new Date(event.start.seconds * 1000);
      const endDate = new Date(event.end.seconds * 1000);

      const client = folder ? await getOrgDataById(folder.client_id) : null;
      const dict_event = {
        id: event.id,
        start: event.start, // Store the full date object to filter later
        end: event.end,
        date: event.date,
        weekdate: capitalizeFirstLetter(
          format(startDate, "EEEE", { locale: fr })
        ),
        startTime: format(startDate, "HH:mm"),
        endTime: format(endDate, "HH:mm"),
        title: event.title || "Titre",
        titre_auto: event.titre_auto,
        description: event.description,
        address: event.address,
        client_name: client ? client.name : event.client_name,
        client_id: folder ? folder.client_id : event.client_id,
        color: event.color,
        duration: event.duration,
        folder: folder ? folder.ref : event.folder,
        link: event.link,
        mandataire_auto: event.mandataire_auto,
        members_id: event.members_id,
        name: event.name || "Titre",
        nom_auto: event.nom_auto,
        num_particulier: event.num_particulier,
        pack_name: folder ? folder.pack_name : event.pack_name,
        pack_ref: folder ? folder.pack_ref : event.pack_ref,
        rappels: event.rappels,
        ville: folder ? folder.ville : event.ville,
        revision: event.revision,
      };

      if (folder) {
        const token = await getOrRefreshFirebaseToken();
        await modifyEvent(
          [],
          event.start,
          event.end,
          event.date || "",
          event.pack_name || "",
          event.pack_ref,
          event.link || "",
          event.mandataire_auto || true,
          event.nom_auto || true,
          event.titre_auto || true,
          event.name || "Titre",
          client.id || "",
          event.emails || [],
          event.num_particulier || "",
          event.msg_content || "",
          folder.nom +
            " " +
            client.name +
            " " +
            folder.pack_name +
            " " +
            folder.ville,
          event.address || "",
          event.ville || "",
          event.postal || "",
          event.description || "",
          folder.id || "",
          event.conductor_id || "",
          event.id || "",
          event.documentcompleted || false,
          event.rdv_confirmed || false,
          event.type || "",
          event.frequency || "",
          event.exception_dates || [],

          token,
          prefix
        );
      }

      if (folder) {
        const eventRef = getRefFromId("event", event.id);
        await updateDocDataFieldApi(folder.ref, "event_ref", eventRef, prefix);
      }

      const weekevents = [...events, dict_event]; // Copy the current events and add the new event
      const allevents = [...all_events, dict_event]; // Copy the current all_events and add the new event
      const weekagendaevents = weekevents;
      setEvents(weekagendaevents);

      setAllEvents(allevents);
      setOpen((prev) => ({ ...prev, [event.id]: true })); // Open he modal

      handleClickVariant("Évènement créé", "success");
    } catch (error) {
      console.error("Error creating event:", error);
      handleClickVariant("Erreur lors de la création de l'évènement", "error");
    }
  };

  useEffect(() => {
    setOptions(
      all_events.map((event) => ({
        value: event.id,
        label: event.name,

        extra_label: event.client_name,
        extra_label_2: event.revision ? "Revisite " + event.revision : "",
        extra_label_3:
          (saved_data?.folders || []).find(
            (folder) => folder.id === event.folder?.id
          )?.reglement?.infos?.phone || "",
        client_type: event.client_type,
      }))
    );
  }, [all_events, searchEvents]);

  // Function to fetch data for the current user
  const handleFetchData = async () => {
    if (currentUser) {
      // Fetch user data by currentUser's ID

      let master = orgData;
      if (workspaceData) {
        setSelectedOperators(["all"]);
        master = await getOrgById(workspaceData.master_id);
      }

      let filters = [
        {
          field: "org_id",
          operator: "==",
          value: master.id,
        },
        {
          field: "role",
          operator: "==",
          value: "operator",
        },
      ];
      const operators = await queryCollection("user", filters);
      setOperators(operators);

      // Update state if the user data is new or changed
    }
  };
  const [height, setHeight] = useState(simplified_view ? 700 : 1700);

  useEffect(() => {
    setHeight(simplified_view ? 700 : 1700);
  }, [simplified_view]);

  function getYPosition(minutes) {
    let top = (height * (minutes - 478)) / 12450;
    let before8h = minutes < 480;
    let after20h = minutes > 1200;
    return before8h ? 0 : after20h ? 0 : top;
  }
  function getHeight(minutes) {
    let event_h = height * (minutes / 12450);
    return event_h;
  }

  // Fetch data when the component mounts or when currentUser changes

  // If the data is still loading or the user is not authenticated, show a loading message
  //loading || !currentUser || !userData
  if (loading || !currentUser || !userData) {
    return (
      <div className="h-full w-full pl-4 flex flex-col gap-2">
        <SmallSpinner />
      </div>
    );
  }

  // Render the client data
  return (
    <div
      className={`flex flex-col relative px-4 w-full h-full max-h-full  overflow-y-auto pb-20   bg-white rounded-xl`}
    >
      {loadingFetchEvents && (
        <div
          className="absolute left-0 top-0 w-full h-screen flex items-center justify-center
     
        pointer-events-none 
        "
        >
          <SmallSpinner></SmallSpinner>
        </div>
      )}
      <div className=" font-medium flex flex-row gap-4 text-hx text-black mb-3 select-none pt-2">
        Planning
        {!workspaceData && (
          <div
            onClick={() => navigateWorkspace("/google-calendar")}
            className="cursor-pointer"
          >
            {userData?.google_calendar ? (
              <div className="border border-blue-400 flex flex-row gap-2 w-fit rounded-full px-2 py-1 text-blue-400 text-h4">
                Sync Google <Icon1 size={18} icon_name="done2" fill="#60a5fa" />
              </div>
            ) : (
              <div className="border border-neutral-400 flex flex-row gap-2 w-fit rounded-full px-2 py-1 text-neutral-400 text-h4">
                Sync Google
              </div>
            )}
          </div>
        )}
        {!workspaceData && (
          <div
            onClick={() => navigateWorkspace("/agenda?source=outlook")}
            className="cursor-pointer"
          >
            {userData?.outlook_calendar ? (
              <div className="border border-blue-400 flex flex-row gap-2 w-fit rounded-full px-2 py-1 text-blue-400 text-h4">
                Sync Outlook <Icon1 size={18} icon_name="done2" fill="#60a5fa" />
              </div>
            ) : (
              <div className="border border-neutral-400 flex flex-row gap-2 w-fit rounded-full px-2 py-1 text-neutral-400 text-h4">
                Sync Outlook
              </div>
            )}
          </div>
        )}
      </div>
      <div className="flex flex-row gap-2 w-full  items-center  min-h-fit">
        <SearchAlgolia
          options={algoliaResults.map((result) => ({
            label: result.name,
            value: result.objectID,
            extra_label: result.client_name,
            extra_label_2: result.revision,
          }))}
          inputValue={searchValue}
          setInputValue={(value) => {
            handleQuerySearch(value);
            if (value.trim() === "") {
              setSearchValue("");
              setHighligtedEvent(null);
            }
          }}
          label="Rechercher un évènement"
          onAction={(e) => {
            console.log("gotoEventName", e);
            gotoEventName(e);
          }}
          classNameCustom="w-c600"
        ></SearchAlgolia>

        {day_view === null && hidden_events.length > 0 && (
          <div className="flex flex-row select-none gap-2 cursor-pointer pl-2 text-shadow_50 items-center text-h3 bg-white rounded-xl ">
            Evènements cachés
            <DropDownGPT03
              items={hidden_events.map((event) => ({
                value: event.id,
                label: event.name,
              }))}
              className={"w-40"}
              value={hidden_events[hidden_index].id}
              onChange={(value) => {
                let event_id = value.value;
                let index = hidden_events.findIndex(
                  (event) => event.id === event_id
                );
                setHiddenIndex(index);
                setSearchValue(hidden_events[index].name);
                gotoEventName({ value: event_id });
              }}
            ></DropDownGPT03>
          </div>
        )}
      </div>
      <Space y={15} />
      <div className=" flex flex-col rounded-md w-full min-h-fit  pb-4  ">
        <PlanningHeader
          operators={operators}
          selected_operators={selected_operators}
          handleSelectedOperators={handleSelectedOperators}
          handleSetDayView={handleSetDayView}
          handleClick={handleClick}
          handleGoToToday={handleGoToToday}
          handleAddLunchBreak={handleAddLunchBreak}
          loadingAddingLunchBreak={loadingAddingLunchBreak}
          show_weekend={show_weekend}
          setShowWeekend={setShowWeekend}
          appState={appState}
          setAppState={setAppState}
          planning_config={planning_config}
          modal_open={modal_open}
          day_view={day_view}
          currentWeekStart={currentWeekStart}
          previousWeek={previousWeek}
          nextWeek={nextWeek}
          loadingWeek={loadingWeek}
          currentWeek={currentWeek}
          weekDates={weekDates}
          orgData={orgData}
          getWeekNumber={getWeekNumber}
          daysOfWeek={daysOfWeek}
          simplified_view={simplified_view}
          setSimplifiedView={setSimplifiedView}
          workspaceData={workspaceData}
          events={events}
        ></PlanningHeader>
        <div className=" bg-transparent   rounded-md w-full min-h-fit cursor-pointer">
          <div className="flex flex-row  w-full min-h-fit ">
            <div className="flex flex-col w-10  " style={{ marginTop: "13px" }}>
              {timeSlots.map((hour, index) => (
                <div
                  key={hour + index.toString()}
                  className="bg-transparent border-t-2 border-r-2 border-wshadow_25 w-10  select-none flex flex-col   font-light h-full p-2 text-h4 text-black justify-start"
                >
                  <div className="flex flex-col">
                    {" "}
                    <div className=" w-full h-full flex justify-center">
                      {hour}h
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <PlanningWeekView
              events={events}
              timeSlots={timeSlots}
              handleClick={handleClick}
              handleOpenModal={handleOpenModal}
              handleCloseModal={handleCloseModal}
              open={open}
              highligtedEvent={highligtedEvent}
              day_view={day_view}
              daysOfWeek={daysOfWeek}
              weekDates={weekDates}
              height={height}
              events_colors={events_colors}
              pack_short_dict={pack_short_dict}
              simplified_view={simplified_view}
              masterData={masterData}
              orgData={orgData}
              userData={userData}
              selected_operators={selected_operators}
              onDelete={onDelete}
              navigateWorkspace={navigateWorkspace}
              workspaceData={workspaceData}
              getYPosition={getYPosition}
              getHeight={getHeight}
              setHighligtedEvent={setHighligtedEvent}
              timeToMinutes={timeToMinutes}
              temporary={temporary}
              setTemporary={setTemporary}
            ></PlanningWeekView>
            <PlanningDayView
              events={events}
              timeSlots={timeSlots}
              handleClick={handleClick}
              handleOpenModal={handleOpenModal}
              handleCloseModal={handleCloseModal}
              open={open}
              highligtedEvent={highligtedEvent}
              day_view={day_view}
              daysOfWeek={daysOfWeek}
              weekDates={weekDates}
              height={height}
              events_colors={events_colors}
              pack_short_dict={pack_short_dict}
              simplified_view={simplified_view}
              masterData={masterData}
              orgData={orgData}
              userData={userData}
              selected_operators={selected_operators}
              onDelete={onDelete}
              navigateWorkspace={navigateWorkspace}
              workspaceData={workspaceData}
              getYPosition={getYPosition}
              getHeight={getHeight}
              setHighligtedEvent={setHighligtedEvent}
              timeToMinutes={timeToMinutes}
              operators={operators}
              temporary={temporary}
              setTemporary={setTemporary}
            ></PlanningDayView>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Planning3;

export function capitalizeFirstLetter(string) {
  if (!string) return "";
  return string.charAt(0).toUpperCase() + string.slice(1);
}
export function isAfterParsedDate(dateA, dateB) {
  // Compare the parsed dates "dd/MM/yyyy"
  const parsedDateA = dayjs(dateA, "DD/MM/YYYY");
  const parsedDateB = dayjs(dateB, "DD/MM/YYYY");
  return parsedDateA.isAfter(parsedDateB) || parsedDateA.isSame(parsedDateB);
}

export const transformEventDB = (query_events = []) => {
  let allEvents = [];
  for (const event of query_events) {
    if (event.start.seconds && event.end.seconds) {
      // Convert Firestore Timestamps to Date
      const startDate = new Date(event.start.seconds * 1000);
      const endDate = new Date(event.end.seconds * 1000);

      let dict_event = event;

      dict_event.startDate = startDate; // Store the full date object to filter later
      dict_event.endDate = endDate;

      dict_event.weekdate = capitalizeFirstLetter(
        format(startDate, "EEEE", { locale: fr })
      );
      dict_event.startTime = format(startDate, "HH:mm");
      dict_event.endTime = format(endDate, "HH:mm");
      dict_event.title = event.title || "Titre";
      dict_event.name = event.name || "Titre";

      dict_event.client_name = event.client_name || "";
      dict_event.pack_name = event.pack_name || "";
      dict_event.pack_ref = event.pack_ref;
      dict_event.ville = event.ville || "";

      allEvents.push(dict_event);
    }
  }
  return allEvents;
};
